import { errorLogger } from "@/Common/helpers/logger";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import { NumberOrString } from "@/Layouts/components/InputComponents/InputValue/types";
import { TInputData } from "@/Layouts/types/InputComponents/InputFormExtension";
import { updateSystemSettings } from "@/Settings/api/SystemSettings/mutations";
import { ISystemSettings } from "@/Settings/types/Common/model";
import { Grid } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type TMinimumWageProps = {
	locationId: string;
	minimumWage?: number;
};

const MinimumWage = (props: TMinimumWageProps) => {
	const { locationId, minimumWage = 0 } = props;
	const queryClient = useQueryClient();

	const { mutate: updateMinimumWage, isPending } = useMutation({
		mutationFn: (input: number) => updateSystemSettings(locationId, { minimumWage: input }, "MINIMUM_WAGE"),
		onSuccess: (result: ISystemSettings) => {
			queryClient.setQueryData(["systemSettings", locationId], (oldData: ISystemSettings) => ({
				...oldData,
				minimumWage: result.minimumWage,
			}));
		},
		onError: (error) => errorLogger(error),
	});

	const handleMinimumWageChange = async (selected: NumberOrString) => {
		if (selected !== minimumWage) {
			const input = Number(selected);
			updateMinimumWage(input);
		}
	};

	return (
		<Grid container direction="row" className="mt-[16px]">
			<InputFormExtension
				data={
					[
						{
							type: "Dollar",
							decimalsEditable: true,
							delta: 0.01,
							min: Number.NEGATIVE_INFINITY,
							max: Number.MAX_VALUE,
							decimals: 2,
						},
					] as TInputData[]
				}
				onActionUpdate={handleMinimumWageChange}
				disabled={isPending}
				sx={{ width: "150px" }}
				value={minimumWage}
			/>
		</Grid>
	);
};

export default MinimumWage;
